import { Component, HostBinding } from '@angular/core';

@Component({
	selector: 'tacho-page-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.scss']
})
export class FooterComponent {

	@HostBinding('class.tacho-page-footer') mainClass: boolean = true;

	public isCancelUsed: boolean = false;


}
